'use es6';

import userInfo from 'hub-http/userInfo';
export const getUserInfo = () => userInfo();